
import { has } from 'lodash';

export default {
  namespaced: true,
  state: {
    savesByComponent: {},
    saves: 0,
  },
  mutations: {
    started(state, uid) {
      if (has(state.savesByComponent, uid)) {
        state.savesByComponent[uid]++;
      }
      state.saves++;
    },
    finished(state, uid) {
      if (has(state.savesByComponent, uid)) {
        state.savesByComponent[uid]--;
      }
      state.saves--;
    },
  },
  getters: {
    saveInProgress: state => state.saves > 0,
    saves: state => state.saves,
  },
};



// WEBPACK FOOTER //
// ./src/stores/Save.js